
import SvgEo from './svg/Eo.vue'
import SvgKroncrv from './svg/Kroncrv.vue'
import SvgNpostart from './svg/Npostart.vue'
import SvgNpo from './svg/Npo.vue'
import SvgNpo1 from './svg/Npo1.vue'
import SvgNpo2 from './svg/Npo2.vue'
import SvgNpo3 from './svg/Npo3.vue'
import SvgZapp from './svg/Zapp.vue'
import SvgNporadio1 from './svg/Nporadio1.vue'
import SvgNporadio2 from './svg/Nporadio2.vue'
import SvgNpo3fm from './svg/Npo3fm.vue'
import SvgNporadio4 from './svg/Nporadio4.vue'
import SvgNporadio5 from './svg/Nporadio5.vue'

export const LOGO_SIZES = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
})

export default {
  name: 'EoBroadcasters',
  components: {
    SvgEo,
    SvgKroncrv,
    SvgNpostart,
    SvgNpo,
    SvgNpo1,
    SvgNpo2,
    SvgNpo3,
    SvgZapp,
    SvgNporadio1,
    SvgNporadio2,
    SvgNpo3fm,
    SvgNporadio4,
    SvgNporadio5,
  },
  props: {
    /**
     * Show EO logo
     */
    eo: {
      type: Boolean,
      default: false,
    },
    /**
     * Show KRO-NCRV logo
     */
    kroncrv: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO Start logo
     */
    npostart: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO logo
     */
    npo: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO1 logo
     */
    npo1: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO2 logo
     */
    npo2: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO3 logo
     */
    npo3: {
      type: Boolean,
      default: false,
    },
    /**
     * Show zapp logo
     */
    zapp: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO Radio 1 logo
     */
    nporadio1: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO Radio 2 logo
     */
    nporadio2: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO 3FM logo
     */
    npo3fm: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO Radio 4 logo
     */
    nporadio4: {
      type: Boolean,
      default: false,
    },
    /**
     * Show NPO Radio 5 logo
     */
    nporadio5: {
      type: Boolean,
      default: false,
    },
    /**
     * Make each logo clickable
     */
    linked: {
      type: Boolean,
      default: false,
    },
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl)
     */
    size: {
      type: String,
      validator: prop => Object.values(LOGO_SIZES).includes(prop),
      default: 'sm',
    },
    /**
     * Style: color
     */
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes () {
      return {
        'eo-broadcasters': true,
        [this.size]: true,
        ['text--' + this.color]: this.color,
      }
    },
  },
}
